import type { BookingDTO } from '@/types/dto/agent';
import type { Components } from '@/types/schemas/agent-schema';
import { getBookingAdmissions } from '@/utils/booking';
import { useMemo } from 'react';

type AppliedPromotionCode =
  Components.Schemas.TurnitOsdmTranslatorApiCommonConnectorModelsConnectorAppliedPromotionCode;

export function useBookingPromoCodes(booking: BookingDTO | null) {
  // A code can appear on multiple admissions, but should only be shown once.
  const bookingPromoCodes = useMemo(() => {
    const byCode = new Map<string, AppliedPromotionCode>();
    getBookingAdmissions(booking).forEach((admission) => {
      admission.appliedPromotionCodes?.forEach((c) => {
        if (c?.code && !byCode.has(c.code)) byCode.set(c.code, c);
      });
    });
    return Array.from(byCode.values());
  }, [booking]);

  return { bookingPromoCodes };
}
